import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import { EAdvancedFilterOptions } from '../models/advanced-filter-options.enum';
import { EAdvancedFilterTimelineDate } from '../models/advanced-filter-timeline-date.enum';

export const IS: TSelectOption = {
  value: EAdvancedFilterOptions.IS,
  label: translate('is') + '...',
  translationKey: 'is',
  suffix: '...',
  operator: EPointSearchOperator.EQUALS,
};

export const IS_NOT: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT,
  label: translate('is_not') + '...',
  translationKey: 'is_not',
  suffix: '...',
  operator: EPointSearchOperator.NOT_EQUALS,
};

export const IS_NOT_MULTI: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_MULTI,
  label: translate('is_not') + '...',
  translationKey: 'is_not',
  suffix: '...',
  operator: EPointSearchOperator.NOT_IN,
};

const IS_NOT_REGEX: TSelectOption = {
  value: EAdvancedFilterOptions.DOES_NOT_CONTAIN,
  label: translate('does_not_contain') + '...',
  translationKey: 'does_not_contain',
  suffix: '...',
  operator: EPointSearchOperator.NOT_REGEX,
};

export const IS_GREATER_THAN: TSelectOption = {
  value: EAdvancedFilterOptions.IS_GREATER_THAN,
  label: translate('is_greater_than') + '...',
  translationKey: 'is_greater_than',
  suffix: '...',
  operator: EPointSearchOperator.GREATER_THAN,
};

export const IS_LESS_THAN: TSelectOption = {
  value: EAdvancedFilterOptions.IS_LESS_THAN,
  label: translate('is_less_than') + '...',
  translationKey: 'is_less_than',
  suffix: '...',
  operator: EPointSearchOperator.LESS_THAN,
};

export const IS_GREATER_THAN_OR_EQUAL: TSelectOption = {
  value: EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL,
  label: translate('is_greater_than_or_equal') + '...',
  translationKey: 'is_greater_than_or_equal',
  suffix: '...',
  operator: EPointSearchOperator.GREATER_THAN_OR_EQUAL,
};

export const IS_LESS_THAN_OR_EQUAL: TSelectOption = {
  value: EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL,
  label: translate('is_less_than_or_equal') + '...',
  translationKey: 'is_less_than_or_equal',
  suffix: '...',
  operator: EPointSearchOperator.LESS_THAN_OR_EQUAL,
};

export const IS_ON_OR_AFTER: TSelectOption = {
  value: EAdvancedFilterOptions.IS_GREATER_THAN_OR_EQUAL,
  label: translate('is_on_or_after') + '...',
  translationKey: 'is_on_or_after',
  suffix: '...',
  operator: EPointSearchOperator.GREATER_THAN_OR_EQUAL,
};

export const IS_ON_OR_BEFORE: TSelectOption = {
  value: EAdvancedFilterOptions.IS_LESS_THAN_OR_EQUAL,
  label: translate('is_on_or_before') + '...',
  translationKey: 'is_on_or_before',
  suffix: '...',
  operator: EPointSearchOperator.LESS_THAN_OR_EQUAL,
};

export const IS_EMPTY: TSelectOption = {
  value: EAdvancedFilterOptions.IS_EMPTY,
  label: translate('is_empty') + '.',
  translationKey: 'is_empty',
  suffix: '.',
  data: [null, ''],
  operator: EPointSearchOperator.IN,
};

export const IS_EMPTY_ARRAY: TSelectOption = {
  value: EAdvancedFilterOptions.IS_EMPTY,
  label: translate('is_empty') + '.',
  translationKey: 'is_empty',
  suffix: '.',
  data: [null, []],
  operator: EPointSearchOperator.IN,
};

export const IS_NOT_EMPTY: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_EMPTY,
  label: translate('is_not_empty') + '.',
  translationKey: 'is_not_empty',
  suffix: '.',
  data: [null, ''],
  operator: EPointSearchOperator.NOT_IN,
};

export const IS_NOT_EMPTY_ARRAY: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_EMPTY,
  label: translate('is_not_empty') + '.',
  translationKey: 'is_not_empty',
  suffix: '.',
  data: [null, []],
  operator: EPointSearchOperator.NOT_IN,
};

export const IS_EMPTY_NUMERICAL: TSelectOption = {
  value: EAdvancedFilterOptions.IS_EMPTY,
  label: translate('is_empty') + '.',
  translationKey: 'is_empty',
  suffix: '.',
  data: [null],
  operator: EPointSearchOperator.EQUALS,
};

export const IS_NOT_EMPTY_NUMERICAL: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_EMPTY,
  label: translate('is_not_empty') + '.',
  translationKey: 'is_not_empty',
  suffix: '.',
  data: [null],
  operator: EPointSearchOperator.NOT_EQUALS,
};

const IS_EMPTY_ASSIGNEE: TSelectOption = {
  value: EAdvancedFilterOptions.IS_EMPTY,
  label: translate('is_empty') + '.',
  translationKey: 'is_empty',
  suffix: '.',
  data: [[]],
  operator: EPointSearchOperator.EQUALS,
};

const IS_NOT_EMPTY_ASSIGNEE: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_EMPTY,
  label: translate('is_not_empty') + '.',
  translationKey: 'is_not_empty',
  suffix: '.',
  data: [[]],
  operator: EPointSearchOperator.NOT_EQUALS,
};

const EXISTS: TSelectOption = {
  value: EAdvancedFilterOptions.EXISTS,
  label: translate('exists') + '.',
  translationKey: 'exists',
  suffix: '.',
  data: [null, ''],
  operator: EPointSearchOperator.IN,
};

const DOES_NOT_EXIST: TSelectOption = {
  value: EAdvancedFilterOptions.DOES_NOT_EXIST,
  label: translate('does_not_exist') + '.',
  translationKey: 'does_not_exist',
  suffix: '.',
  data: [null, ''],
  operator: EPointSearchOperator.IN,
};

const CONTAINS: TSelectOption = {
  value: EAdvancedFilterOptions.CONTAINS,
  label: translate('contains') + '...',
  translationKey: 'contains',
  suffix: '...',
  operator: EPointSearchOperator.REGEX,
};

const IS_CHECKED: TSelectOption = {
  value: EAdvancedFilterOptions.IS_CHECKED,
  label: translate('is_checked') + '.',
  translationKey: 'is_checked',
  suffix: '.',
  operator: EPointSearchOperator.EQUALS,
  data: [true],
};

const IS_NOT_CHECKED: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_CHECKED,
  label: translate('is_unchecked') + '.',
  translationKey: 'is_unchecked',
  suffix: '.',
  operator: EPointSearchOperator.IN,
  data: [false, null],
};

export const IS_ANY_OF: TSelectOption = {
  value: EAdvancedFilterOptions.IS_ANY_OF,
  label: translate('is_any_of') + '...',
  translationKey: 'is_any_of',
  suffix: '...',
  operator: EPointSearchOperator.IN,
};

export const IS_NONE_OF: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NONE_OF,
  label: translate('is_none_of') + '...',
  translationKey: 'is_none_of',
  suffix: '...',
  operator: EPointSearchOperator.NOT_IN,
};

export const IS_ALL_OF: TSelectOption = {
  value: EAdvancedFilterOptions.IS_ALL_OF,
  label: translate('is_all_of') + '...',
  translationKey: 'is_all_of',
  suffix: '...',
  operator: EPointSearchOperator.EQUALS,
};

export const IS_NOT_ALL_OF: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_ALL_OF,
  label: translate('is_not_all_of') + '...',
  translationKey: 'is_not_all_of',
  suffix: '...',
  operator: EPointSearchOperator.NOT_EQUALS,
};

export const IS_BEFORE: TSelectOption = {
  value: EAdvancedFilterOptions.IS_BEFORE,
  label: translate('is_before') + '...',
  translationKey: 'is_before',
  suffix: '...',
  operator: EPointSearchOperator.LESS_THAN,
};

export const IS_BEFORE_TIMELINE: TSelectOption = {
  ...IS_BEFORE,
  operator: EPointSearchOperator.LESS_THAN,
};

export const IS_AFTER: TSelectOption = {
  value: EAdvancedFilterOptions.IS_AFTER,
  label: translate('is_after') + '...',
  translationKey: 'is_after',
  suffix: '...',
  operator: EPointSearchOperator.GREATER_THAN,
};

export const IS_AFTER_TIMELINE: TSelectOption = {
  ...IS_AFTER,
  timelinePosition: 'END',
};

export const IS_BETWEEN: TSelectOption = {
  value: EAdvancedFilterOptions.IS_BETWEEN,
  label: translate('is_between') + '...',
  translationKey: 'is_between',
  suffix: '...',
  operator: EPointSearchOperator.BETWEEN,
};

const IS_FLAGGED: TSelectOption = {
  value: EAdvancedFilterOptions.IS_FLAGGED,
  label: translate('is_flagged') + '.',
  translationKey: 'is_flagged',
  suffix: '.',
  operator: EPointSearchOperator.EQUALS,
  data: [true],
};

const IS_NOT_FLAGGED: TSelectOption = {
  value: EAdvancedFilterOptions.IS_NOT_FLAGGED,
  label: translate('is_unflagged') + '.',
  translationKey: 'is_unflagged',
  suffix: '.',
  operator: EPointSearchOperator.IN,
  data: [false, null],
};

export const START_DATE: TSelectOption = {
  value: EAdvancedFilterTimelineDate.START_DATE,
  label: translate('start_date'),
  translationKey: 'start_date',
  suffix: '.',
  operator: EPointSearchOperator.EQUALS,
  timelinePosition: 'START',
};

export const END_DATE: TSelectOption = {
  value: EAdvancedFilterTimelineDate.END_DATE,
  label: translate('end_date'),
  translationKey: 'end_date',
  suffix: '.',
  operator: EPointSearchOperator.EQUALS,
  timelinePosition: 'END',
};

export const IS_A_PART_OF: TSelectOption = {
  value: EAdvancedFilterOptions.IS_A_PART_OF,
  label: translate('is_a_part_of'),
  translationKey: 'is_a_part_of',
  suffix: '.',
  operator: EPointSearchOperator.IN,
};

export const priorityOperatorOptions = [IS, IS_NOT, IS_ANY_OF, IS_NONE_OF];
export const percentageOperatorWithEqualToOptions = [
  IS,
  IS_NOT,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_GREATER_THAN_OR_EQUAL,
  IS_LESS_THAN_OR_EQUAL,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
];
export const formulaOperatorWithEqualsToOptions = [
  IS,
  IS_NOT,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_GREATER_THAN_OR_EQUAL,
  IS_LESS_THAN_OR_EQUAL,
];
export const locationOperatorOptions = [EXISTS, DOES_NOT_EXIST];
export const multiListOperatorOptions = [
  IS,
  IS_NOT_MULTI,
  IS_ANY_OF,
  IS_NONE_OF,
  IS_ALL_OF,
  IS_EMPTY_ARRAY,
  IS_NOT_EMPTY_ARRAY,
];

export const listOperatorOptions = [IS, IS_NOT, IS_A_PART_OF, IS_EMPTY, IS_NOT_EMPTY];
export const numberSequenceOperatorOptions = [IS, IS_NOT, IS_GREATER_THAN, IS_LESS_THAN];

export const numberOperatorWithEqualsToOptions = [
  IS,
  IS_NOT,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_GREATER_THAN_OR_EQUAL,
  IS_LESS_THAN_OR_EQUAL,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
];

export const advancedTimelineDatesOperatorOptionsExtended = [
  START_DATE,
  END_DATE,
  IS_BETWEEN,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
];

export const timelineOperatorOptionsExtended = [
  IS,
  IS_BEFORE_TIMELINE,
  IS_AFTER_TIMELINE,
  IS_BETWEEN,
  IS_ON_OR_AFTER,
  IS_ON_OR_BEFORE,
];
export const flaggedOperatorOptions = [IS_FLAGGED, IS_NOT_FLAGGED];
export const createdByOperatorOptions = [IS, IS_NOT, IS_ANY_OF, IS_NONE_OF];
export const assigneeOperatorOptions = [
  IS,
  IS_NOT,
  IS_ANY_OF,
  IS_NONE_OF,
  IS_ALL_OF,
  IS_EMPTY_ASSIGNEE,
  IS_NOT_EMPTY_ASSIGNEE,
];

export const durationOperatorOptions = [
  IS,
  IS_NOT,
  IS_GREATER_THAN,
  IS_LESS_THAN,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
];

export const accountSiteOperatorOptions = [IS_ANY_OF, IS_NONE_OF];

export const textOperationWithMandatoryOptions = [
  CONTAINS,
  IS_NOT_REGEX,
  IS,
  IS_NOT,
  IS_EMPTY,
  IS_NOT_EMPTY,
];

export const titleOperationOptions = [CONTAINS, IS_NOT_REGEX, IS, IS_NOT];

export const tagExtendedOperatorOptions = [
  IS,
  IS_NOT,
  IS_ANY_OF,
  IS_NONE_OF,
  IS_ALL_OF,
  IS_NOT_ALL_OF,
  IS_EMPTY_ARRAY,
  IS_NOT_EMPTY_ARRAY,
];

export const checkboxOperationOptions = [IS_CHECKED, IS_NOT_CHECKED];

export const dateFilterOperatorOptionsExtended = [
  IS,
  IS_BEFORE,
  IS_AFTER,
  IS_BETWEEN,
  IS_EMPTY_NUMERICAL,
  IS_NOT_EMPTY_NUMERICAL,
  IS_ON_OR_AFTER,
  IS_ON_OR_BEFORE,
];
export const dateFilterUpdatedOperatorOptionsExtended = [
  IS,
  IS_BEFORE,
  IS_AFTER,
  IS_BETWEEN,
  IS_ON_OR_AFTER,
  IS_ON_OR_BEFORE,
];

export const dateFilterCreatedOperatorOptionsExtended = [
  IS,
  IS_BEFORE,
  IS_AFTER,
  IS_BETWEEN,
  IS_ON_OR_AFTER,
  IS_ON_OR_BEFORE,
];
export const advancedStatusOptions = [IS, IS_NOT, IS_ANY_OF, IS_NONE_OF];

export const filterTypeMatchingOperators = {
  PRIORITY: priorityOperatorOptions,
  PERCENTAGE: percentageOperatorWithEqualToOptions,
  LOCATION: locationOperatorOptions,
  MULTI_LIST: multiListOperatorOptions,
  LIST: listOperatorOptions,
  SEQUENCE_NUMBER: numberSequenceOperatorOptions,
  NUMBER: numberOperatorWithEqualsToOptions,
  COST: numberOperatorWithEqualsToOptions,
  TIMELINE: [...timelineOperatorOptionsExtended, IS_EMPTY_NUMERICAL, IS_NOT_EMPTY_NUMERICAL],
  FLAGGED: flaggedOperatorOptions,
  CREATED_BY: createdByOperatorOptions,
  ASSIGNEE: assigneeOperatorOptions,
  DURATION: durationOperatorOptions,
  'ACCOUNT/SITE': accountSiteOperatorOptions,
  TITLE: titleOperationOptions,
  RICH_TEXT: textOperationWithMandatoryOptions,
  TEXT: textOperationWithMandatoryOptions,
  TAG: tagExtendedOperatorOptions,
  CHECKBOX: checkboxOperationOptions,
  DATE: dateFilterOperatorOptionsExtended,
  DATE_UPDATED: dateFilterUpdatedOperatorOptionsExtended,
  DATE_CREATED: dateFilterCreatedOperatorOptionsExtended,
  STATUS: advancedStatusOptions,
  FORMULA: formulaOperatorWithEqualsToOptions,
};
